import { useState } from "react";
import { FileText } from "lucide-react";
import { cn } from "@/lib/cn";
import { fileExt, fileName, thumbnailUrl } from "@/lib/attachments";

/** A square preview of an attachment; a file tile with its type when there is none. */
export function AttachmentThumb({ url, size = 160, className }: { url: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  const thumb = thumbnailUrl(url, size);
  if (thumb && !failed) {
    return (
      <img
        src={thumb}
        alt=""
        loading="lazy"
        onError={() => setFailed(true)}
        className={cn("shrink-0 rounded border border-slate-200 bg-slate-50 object-cover", className)}
      />
    );
  }
  return (
    <span className={cn("flex shrink-0 flex-col items-center justify-center gap-0.5 rounded border border-slate-200 bg-slate-50 text-primary", className)}>
      <FileText size={18} />
      {fileExt(url) && <span className="text-[10px] font-semibold text-slate-500">{fileExt(url)}</span>}
    </span>
  );
}

/** Attachments as a row of previews with their names; each opens the original. */
export function AttachmentGallery({ urls }: { urls: string[] }) {
  return (
    <div className="flex flex-wrap gap-3">
      {urls.map((u, i) => (
        <a key={i} href={u} target="_blank" rel="noreferrer" className="group w-24" title={fileName(u)}>
          <AttachmentThumb url={u} size={192} className="h-24 w-24 group-hover:border-primary" />
          <span className="mt-1 block truncate text-xs text-slate-600 group-hover:text-primary group-hover:underline">{fileName(u)}</span>
        </a>
      ))}
    </div>
  );
}
